import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import {
  selectBeesById,
  selectInteractibleplantsByBeeId, selectSelectedBeeIds,
} from '../../../../ducks/bees';

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

const StyledSelect = styled(Select)`
  width: 250px;
  z-index: 98;
`;

const IsRelevantFilter = ({ label, value, handleChange }) => {
  const interactiblePlantsByBeeId = useSelector(selectInteractibleplantsByBeeId);
  const beesById = useSelector(selectBeesById);
  const relevantBeeIds = useSelector(selectSelectedBeeIds);

  if (!interactiblePlantsByBeeId || !relevantBeeIds) {
    return null;
  }

  const options = relevantBeeIds.map((beeId) => ({
    value: beeId,
    label: beesById[beeId].dutchName,
  }));

  return (
    <Wrapper>
      <span className="mr-3">{label}</span>
      <StyledSelect
        options={options}
        onChange={handleChange}
        value={value}
        placeholder="Alle bijen"
        isClearable
        isSearchable
      />
    </Wrapper>

  );
};

IsRelevantFilter.propTypes = {
  label: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default IsRelevantFilter;
